import React from 'react';
import {Stack} from "@mui/material";

const ListOfKeyIntelligenceQuestions = () => {
    return (
        <Stack p={2} spacing={2} overflow={'auto'}>
            List of Key Intelligence Questions Page
        </Stack>
    );
};

export default ListOfKeyIntelligenceQuestions;